import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { applyThemeToDocument, isDarkModeAtom } from './atoms';

/** Keeps the document shell in sync with the dark-mode atom (e.g. after hydration). */
export function ThemeSync() {
  const isDark = useAtomValue(isDarkModeAtom);

  useEffect(() => {
    applyThemeToDocument(isDark);
  }, [isDark]);

  return null;
}
